import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { RouterToUrlQuery } from 'react-url-query';

import Navigation from './components/presentation/Navigation/Navigation';
import SearchPage from './views/search';
import FoodDetail from './views/foodDetail';
//import GlossaryPage from './views/glossary';
//import FAQPage from './views/faq';
//import AboutPage from './views/about';
//import TermsPage from './views/terms';
import Footer from './components/presentation/Footer/Footer';
import RemoveTrailingSlash from './components/util/RemoveTrailingSlash';

import withTracker from './withTracker';

import './assets/css/bootstrap.css';
import './assets/css/custom.css';


// function fireTracking() {
//     //alert(window.location);
//     ReactGA.pageview(window.location);
// }


class App extends Component {
  // ReactGA.initialize('UA-2098612-31'); //Unique Google Analytics tracking number
  // ReactGA.pageview(window.location.pathname);

  render() {
    return (
      <Router>
        <RouterToUrlQuery>
          <div className="MainRouter">
            <Navigation />

            <main>
              <Route path="/" render={RemoveTrailingSlash} />
              <Switch>
                <Route path="/search/food/:recordid" render={(props) => {
                  // redirect lower case recordid to upper case
                  // do it here to do before fetching from the API
                  const recordid = props.match.params.recordid;
                  if (/[a-z]/.test(recordid.charAt(0))) {
                    return <Redirect to={`/search/food/${recordid.toUpperCase()}`} />;
                  }
                  return <FoodDetail {...props} />;
              }} />
                <Route strict path="/search" component={withTracker(SearchPage)} />
                <Route render={() => (
                  <Redirect to="/search" />
                )} />
              </Switch>
            </main>

            <Footer />
          </div>
        </RouterToUrlQuery>
      </Router>
    );
  }

}




export default App;



// WEBPACK FOOTER //
// ./src/App.js